export default __webpack_public_path__ + "static/media/logos.cb189a3d.png";